import { faKey, faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'components/base/Button';
// import AuthSocialButtons from 'components/common/AuthSocialButtons';
import { Col, Form, Row } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import authenticationService from 'services/authentication';
import { useState, useContext } from 'react';
import { UserContext } from 'contexts/UserContext';
import { jwtDecode } from 'jwt-decode';

const SignInForm = ({ layout }: { layout: 'simple' | 'card' | 'split' }) => {
  const userContext = useContext(UserContext);

  if (!userContext) {
    throw new Error('UserContext is not available');
  }

  const { setUser } = userContext;
  const [loginError, setLoginError] = useState('');
  const navigate = useNavigate();
  const handleLogin = () => {
    const email = document.getElementById('email') as HTMLInputElement;
    const password = document.getElementById('password') as HTMLInputElement;
    const rememberme = document.getElementById(
      'remember-me'
    ) as HTMLInputElement;
    authenticationService
      .login(email.value, password.value, rememberme.checked)
      .then(response => {
        localStorage.setItem('email', email.value);
        localStorage.setItem('jwt', response.token);
        localStorage.setItem('refreshToken', response.refreshToken);
        localStorage.setItem('expiresAt', response.expiresAt);
        localStorage.setItem('userId', response.userId);
        // Decode the token to get the role
        const decodedToken = jwtDecode<DecodedToken>(response.token);
        const role =
          decodedToken[
            'http://schemas.microsoft.com/ws/2008/06/identity/claims/role'
          ];
        setUser({
          userId: response.userId,
          role: role === 'admin' ? 'Admin' : 'Member',
          avatar: response.avatar,
          firstName: response.firstName,
          lastName: response.lastName
        });

        navigate('/dashboard/project-management');
        console.log(Response);
      })
      .catch(error => {
        console.log('respose', error);
        if (error.response && error.response.status === 401) {
          // Set the error message
          setLoginError('Invalid email or password. Please try again.');
        } else {
          // Handle other errors
          setLoginError(
            'An unexpected error occurred. Please try again later.'
          );
        }
      });
  };
  return (
    <>
      <div className="text-center mb-7">
        <h3 className="text-1000">Sign In</h3>
        <p className="text-700">Access your account</p>
      </div>
      {/* <AuthSocialButtons title="Sign in" /> */}
      {/* <div className="position-relative">
        <hr className="bg-200 mt-5 mb-4" />
        <div className="divider-content-center">or use email</div>
      </div> */}
      <Form.Group className="mb-3 text-start">
        <Form.Label htmlFor="email"></Form.Label>
        <div className="form-icon-container">
          <Form.Control
            id="email"
            type="email"
            className="form-icon-input"
            placeholder="name@example.com"
          />
          <FontAwesomeIcon icon={faUser} className="text-900 fs-9 form-icon" />
        </div>
      </Form.Group>
      <Form.Group className="mb-3 text-start">
        <Form.Label htmlFor="password"></Form.Label>
        <div className="form-icon-container">
          <Form.Control
            id="password"
            type="password"
            className="form-icon-input"
            placeholder="Password"
          />
          <FontAwesomeIcon icon={faKey} className="text-900 fs-9 form-icon" />
        </div>
      </Form.Group>
      <Row className="flex-between-center mb-7">
        <Col xs="auto">
          <Form.Check type="checkbox" className="mb-0">
            <Form.Check.Input
              type="checkbox"
              name="remember-me"
              id="remember-me"
              defaultChecked
            />
            <Form.Check.Label htmlFor="remember-me" className="mb-0">
              Remember me
            </Form.Check.Label>
          </Form.Check>
        </Col>
        <Col xs="auto">
          <Link
            to={`/pages/authentication/${layout}/forgot-password`}
            className="fs-9 fw-semi-bold"
          >
            Forgot Password?
          </Link>
        </Col>
      </Row>
      <Button variant="primary" className="w-100 mb-3" onClick={handleLogin}>
        Sign In
      </Button>
      <div className="text-center">{loginError && <p>{loginError}</p>}</div>
      <div className="text-center">
        <Link
          to={`/pages/authentication/${layout}/sign-up`}
          className="fs-9 fw-bold"
        >
          Create an account
        </Link>
      </div>
    </>
  );
};

type DecodedToken = {
  [key: string]: string | undefined;
  'http://schemas.microsoft.com/ws/2008/06/identity/claims/role'?: string;
};
export default SignInForm;
